/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface BonusPointsTransferFundsRequestApiModel {
  /**
   * Operation amount
   */
  amount: number;
  /**
   * Currency ISO code
   */
  currency: string;
  /**
   * Recipient of funds User identifier (phone number, email, external identifier)
   */
  recipient_id: string;
  /**
   * Type of recipient user identity (optional)
   */
  recipient_id_type?: BonusPointsTransferFundsRequestApiModelRecipientIdTypeEnum | null;
}
export enum BonusPointsTransferFundsRequestApiModelRecipientIdTypeEnum {
  Phone = 'phone',
  Email = 'email',
  ExternalId = 'external-id',
  Qr = 'qr'
}
